import React, { useContext, useEffect, useState } from "react";
import { Container, Row, Col, ListGroup, Card, Button } from "react-bootstrap";
import { Context } from "../../index";
import { observer } from "mobx-react-lite";
import {
    FaUser,
    FaList,
    FaLock,
    FaCog,
    FaCreditCard,
    FaFileInvoice,
    FaHeadset,
    FaHeart,
    FaSignOutAlt,
    FaArrowAltCircleRight
} from "react-icons/fa";
import ColAuthor from "../../components/columns/ColAuthor";
import UserProfile from "../../components/useraccount/UserProfile";
import UserChangePass from "../../components/useraccount/UserChangePass";
import PaymentComp from "../../components/payment/PaymentComp";
import UserPayment from "../../components/useraccount/UserPayment";
import UserSupport from "../../components/useraccount/UserSupport";
import UserWishlist from "../../components/useraccount/UserWishlist";
import {loadStripe} from "@stripe/stripe-js";
import UserPaySubscription from "../../components/payment/UserPaySubscription";
import UserPaySubscriptionFull from "../../components/payment/UserPaySubscriptionFull";
import PartnerDashboard from "../../components/useraccount/PartnerDashboard";
import {MAIN_ROUTE} from "../../utils/consts";

const menuItems = [
    { key: "profile", label: "Profile", icon: <FaUser className="text-success mb-1"/> },
    { key: "security", label: "Security", icon: <FaLock className="text-success mb-1"/> },
    { key: "support", label: "Support", icon: <FaHeadset className="text-success mb-1"/> },
    { key: "wishlist", label: "Wishlist", icon: <FaHeart className="text-danger mb-1"/> },
    { key: "partner", label: "Affiliate", icon: <FaList className="text-success mb-1"/> },
  //  { key: "logout", label: "LogOut", icon: <FaArrowAltCircleRight className="text-success mb-1"/> },
];

const content = {
    profile: <UserProfile />,
    security: <UserChangePass />,
   // payment: <PaymentComp />,
    support: <UserSupport />,
    wishlist: <UserWishlist />,
    partner: <PartnerDashboard />,
};

const getInitialAccountTab = () => {
    const searchTab = new URLSearchParams(window.location.search).get("tab");
    if (content[searchTab]) return searchTab;

    const hash = window.location.hash.replace(/^#/, "").split("&")[0];
    return content[hash] ? hash : "profile";
};

const UserAccount = observer(() => {

    const { user } = useContext(Context);
    const [activeKey, setActiveKey] = useState(getInitialAccountTab);
    const [hoveredItemId, setHoveredItemId] = useState(null);

    useEffect(() => {
        const syncTabFromHash = () => {
            const nextKey = getInitialAccountTab();
            if (nextKey !== activeKey) setActiveKey(nextKey);
        };

        window.addEventListener("hashchange", syncTabFromHash);
        return () => window.removeEventListener("hashchange", syncTabFromHash);
    }, [activeKey]);

    const logOut = () => {
        localStorage.removeItem('token');
        user.setUser({});
        user.setIsAuth(false);
        window.location.assign(MAIN_ROUTE);
    };

    return (
        <Container fluid style={{ padding: 30, marginTop: -30 }}>
            <Row>
                {/* Левая колонка с меню */}
                <Col md={2}>
                    <div>
                        <h4 style={{marginBottom: '-10px'}} className="mx-auto p-2">Settings</h4>
                        <div style={{marginBottom: '5px', fontSize: 'small'}} className="mx-auto p-2">Setup Your Data:
                        </div>

                        <ListGroup variant="flush">
                            {menuItems.map((item) => (
                                <ListGroup.Item
                                    key={item.key}
                                    action


                                    className={`list-group-item list-group-item-action small shadow-sm ${activeKey === item.key ? 'list-group-item-success' : ''}`}


                                    onClick={() => setActiveKey(item.key)}
                                    onMouseEnter={() => setHoveredItemId(item.key)}
                                    onMouseLeave={() => setHoveredItemId(null)}
                                    style={{
                                        cursor: 'pointer',
                                        borderRadius: '.25rem',
                                        transition: 'transform .2s',
                                        boxShadow:
                                            hoveredItemId === item.key || activeKey === item.key
                                                ? '0px 4px 12px rgba(0, 0, 0, 0.1)'
                                                : 'none',
                                    }}
                                >
                                    <div className="d-flex align-items-center">
                                        <span className="me-2">{item.icon}</span>
                                        {item.label}
                                    </div>
                                </ListGroup.Item>

                            ))}
                            <ListGroup.Item
                                action
                                variant="outline-danger"
                                className="mt-0 d-flex align-items-center list-group-item list-group-item-action small shadow-sm"
                                onClick={logOut}
                            >
                                <FaSignOutAlt className="me-2" />
                                Log Out
                            </ListGroup.Item>
                        </ListGroup>
                    </div>
                </Col>

                {/* Правая колонка с контентом */}
                <Col md={8}>
                    <Card className="shadow-lg p-3 bg-white rounded">

                        <div>{content[activeKey]}</div>

                        {/* Добавляем кнопку "View All" */}

                    </Card>
                </Col>
                <Col md={6}>

                </Col>

            </Row>
        </Container>
    );
});

export default UserAccount;
